import * as React from "react";

import "./Questions.css";

export default class extends React.Component<
  // Props
  {
    questions: any[];
    currentQuestion: number;
    updateWeightings: any;
    nextQuestion: any;
    previousQuestion: any;
    passQuestionsAndAnswers: any;
    goTo: any;
    readyToProceed: boolean;
  },
  // States
  {
    questionsAndAnswers: any[];
    activeAnswer: number;
    readyToProceed: boolean;
  }
> {
  constructor(props: any) {
    super(props);
  }

  componentWillReceiveProps(props: any) {
    let answerChosen = this.state.questionsAndAnswers[props.currentQuestion]
      .answerChosen;
    this.setState({
      activeAnswer: answerChosen,
      readyToProceed: answerChosen ? true : props.readyToProceed
    });
  }

  componentDidMount() {
    this.setState({
      questionsAndAnswers: this.props.questions
    });
  }

  questionClickedWithWeightings(weightings: number[], i: number) {
    let questionsAndAnswers = this.state.questionsAndAnswers;

    questionsAndAnswers[this.props.currentQuestion].answerChosen = i;
    this.setState({
      activeAnswer: i,
      questionsAndAnswers: questionsAndAnswers
    });

    // Pass up to App
    this.props.passQuestionsAndAnswers(questionsAndAnswers);
  }

  backButtonClick() {
    // console.log(this.props.currentQuestion);
    if (this.props.currentQuestion > 0) {
      this.props.previousQuestion();
    }
  }

  reload() {
    // If first question, go back to home by reloading
    location.reload();
  }

  nextButtonClick() {
    this.setState({
      activeAnswer: -1
    });
    if (
      this.props.currentQuestion >=
      this.state.questionsAndAnswers.length - 1
    ) {
      this.props.goTo("results");
    } else {
      this.props.nextQuestion();
    }
  }

  renderQuestion(i: number) {
    const question = this.state.questionsAndAnswers[i];
    // console.log("render: ", i, "props", this.props.currentQuestion);

    const answers = question.answers.map((answer: any, index: number) => (
      <li key={index}>
        <a
          className={
            "answer " + (this.state.activeAnswer === index ? "active" : "")
          }
          key={index}
          onClick={e =>
            this.questionClickedWithWeightings(answer.weightings, index)
          }
        >
          <span>{answer.content}</span>
        </a>
      </li>
    ));

    // console.log(question);
    return (
      <div className="sidebar">
        <h1>The Future Workforce: How prepared are you and your business?</h1>
        <header>
          <h2>{question.content}</h2>
          <div className="question_counter">
            Question
            <span>
              {this.props.currentQuestion + 1}/
              {this.state.questionsAndAnswers.length}
            </span>
          </div>
        </header>
        <ol>{answers}</ol>
        <footer>
          {this.props.currentQuestion == 0 ? (
            <button onClick={() => this.reload()} className="button--back">
              Start over
            </button>
          ) : (
            // Have answers stored against questions, and weightings calculated en-masse each update.
            <button
              onClick={() => this.backButtonClick()}
              className="button--back"
            >
              Back
            </button>
          )}
          <button
            onClick={() => this.nextButtonClick()}
            disabled={!this.state.readyToProceed}
          >
            Next
          </button>
        </footer>

        <div className="arc" />
        {/* <svg
          xmlns="http://www.w3.org/2000/svg"
          width="114"
          height="1080"
          viewBox="0 0 114.31 1080"
          role="presentation"
        >
          <path
            d="M0,0,.15,1080C73.51,915.12,114.31,732.56,114.31,540.45,114.31,347.87,73.46,165,0,0Z"
            fill="#fff"
          />
        </svg> */}
      </div>
    );
  }

  render() {
    if (!this.state) {
      return null; // loading
    }

    return (
      <div className="questions">
        {this.renderQuestion(this.props.currentQuestion)}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Questions.tsx